import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../api.service';
import { localStorageService } from '../../localstorage.service';


@Component({
    selector: 'app-set-dnd',
    imports: [FormsModule],
    templateUrl: './set-dnd.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './set-dnd.component.scss'
})
export class SetDndComponent {
  public emails = '';
  public success_message = '';
  public admin_id = '';
  stopReminder = false;
  stopTrainingReminder = false;
  stopContractReminder = false;
  constructor(private _api: ApiService, private _local: localStorageService) {
    this.admin_id = this._local.customGetItem('admin_profile') ? (this._local.customGetItem('admin_profile').admin_id) : 0
  }
  setDND() {
    if (this.emails && this.emails.length) {
      this._api.api({ email_list: this.emails, admin_id: this.admin_id, stop_reminder: this.stopReminder ? 1 : 0, stop_training_reminder: this.stopTrainingReminder ? 1 : 0, stop_contract_reminder: this.stopContractReminder ? 1 : 0}, 'auth/set_dnd_email')
        .subscribe((data: any) => {
          console.log(data);
          this.emails = '';
          this.success_message = data.message;
          setTimeout(() => {
            this.success_message = ''
          }, 5000)
        })
    }
  }
}
